module.exports = __webpack_public_path__ + "media/icons/telegram-f647f49d.svg";